import Schema from 'AppReact/schema';

export default {
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
  icon: Schema({}, 'object', { defaultValue: null }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  startDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  editingDate: Schema('string', 'primitive-nullable', { defaultValue: 'startDate' }),
};
